import React from 'react';
import Link from '@mui/material/Link';
import last from 'lodash/fp/last';
import PropTypes from 'prop-types';
import translate from '@/lib/intl/translate';
import { EmailAttachmentPropType } from '../types';

export default function EmailAttachments({ attachments }) {
  return (
    <>
      <h3 className="pb-2 type-body4">{translate('EMAIL_ATTACHMENTS')}</h3>
      {(Array.isArray(attachments) ? attachments : [attachments]).map(
        ({ fileName, fileLocator, s3Url }) => (
          <Link
            className="block text-text-primary type-body3"
            download
            href={s3Url}
            key={`${fileName}-${last(fileLocator.split('/'))}`}
          >
            {last(fileName.split('/'))}
          </Link>
        ),
      )}
    </>
  );
}

EmailAttachments.propTypes = {
  attachments: PropTypes.oneOfType([
    PropTypes.arrayOf(EmailAttachmentPropType),
    EmailAttachmentPropType,
  ]).isRequired,
};
